import * as Sentry from '@sentry/react';
import React, { useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert } from '@mui/material';
import { Button, Modal, Snackbar } from '@mui/material';
import { Close, Edit } from '@mui/icons-material';

import ActivityForm from 'features/forms/Activity';
import AdminVisuals from 'features/AdminVisuals';
import AssignmentList from "components/AssignmentLists";
import COLOR from 'utils/constants/color';
import ChapterManagementBook from 'features/ChapterManagementBook';
import AdminDashboardClassDataSkeletonPage from 'pages/AdminDashboardClassDataSkeletonPage';
import AdminDashboardHomeSkeletonPage from 'pages/AdminDashboardHomeSkeletonPage';
import ClassForm from 'features/forms/Class';
import CotationLoader from 'components/CotationLoader';
import Gradebook from 'features/Gradebook';
import Loading from 'components/Loading';
import LoadingWrapper from 'components/LoadingWrapper';
import QuizForm from 'features/forms/Quiz';
import Section from 'components/Section';
import SentryWrap from 'components/Sentry';
import { Tune } from '@mui/icons-material';
import WelcomeVideo from 'components/WelcomeVideo';
import { filter, find, get, has, debounce } from "lodash";
import dayjs from 'utils/dayjsConfig';
import queryString from 'query-string';
import styled from 'styled-components';
import { getCurrentUser } from 'aws-amplify/auth';
import { Col, Drawer, Dropdown, Row, Tooltip } from 'antd';
import { EyeFilled } from '@ant-design/icons';
import { locationImg, userRobert } from "utils/assets/images";
import myAssignSvg from "../utils/assets/images/my-assign.svg";
import { handleCheckCode, handleDeleteClassData, handleGetClass } from 'store/classes/thunks';
import { getRandomCotation } from "utils/methods/math";
import { handeleCanvasUserClasses, handleSyncGrade, handleUpdateCanvasAssignment, handleListCanvasAssignmentCat, handleSyncAssignment, handleSyncClassGradeToCanvas } from "store/canvas/thunks";
import { handleSyncAssignmentDataSchoology, handleSyncSchoologyClassesGrades } from 'store/schoology/thunks';
import { handleListClassActivities, handleUpdateClassActivity } from 'store/classActivities/thunks';
import { handleListClassQuizzes, handleUpdateClassQuiz } from 'store/classQuizzes/thunks';
import { handleUpdateGoogleAssignment } from 'store/googleClassRoom/thunks';
import { handleListOrgUsers } from 'store/users/thunks';
import { handleListClassUsers, handleListUserClasses } from 'store/userClasses/thunks';
import { handleDeleteUserFromOrganization } from 'store/organizations/thunks';
import { handleGetUserPreference } from 'store/userPreference/thunks';
import { handleListActivities, handleListCustomAssignment } from 'store/activities/thunks';
import { handleListBubbleClassNotes } from 'store/notes/thunks';
import { handleListClassBookmarks } from 'store/bookmark/thunks';
import { handleListClassSubmissions } from 'store/submissions/thunks';
import { handleListInstructionByUser } from "store/instructions/thunks";
import { handleListOrgsByParent } from 'store/organizations/thunks';
import { handleListQuizzes } from 'store/quizzes/thunks';
import { handleListUserBooks } from 'store/userBooks/thunks';
import { handleUpdateSchoologyAssignment } from 'store/schoologyauth/thunks';
import { makeStyles } from 'utils/styles/mui';
import { useClassGameActivity } from 'store/one_game/selectors';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { useCurrentOrgPermission } from 'store/organizations/selectors';
import { useDemoStatus } from 'store/users/selectors';
import { useFullScreenTabDetect } from 'containers/chat/hooks';
import { useSchoologyAssignment, useSchoologyGradeCategory } from "store/schoologyauth/selectors";
import { v4 } from 'uuid';
import useMobileDeviceDetection, { useIsMobileDevice, useTabletDetection } from './chat/hooks';
import { handleSyncClassworkAssignment, handleSyncClassworkGeades } from "store/googleClassRoom/thunks";
import { handleSyncLicesneUses } from 'store/licences/thunks';
import { useUI } from 'store/UI/selectors';
import { handleGetWelcomeVideos } from 'store/welcomeVideo/thunks';
import { useWelcomeVideos } from 'store/welcomeVideo/selectors';
import { useClassBooks } from 'components/hooks/books/useClassBooks';
import { classCardHandleStudentSync } from 'components/classCardHandleStudentSync';


const ACTIVE_BTN_COLOR = `linear-gradient(to bottom right, ${COLOR.indigo100} , ${COLOR.indigo300})`
const DEACTIVE_BTN_COLOR = `linear-gradient(to right, ${COLOR.lightseagreen100} , ${COLOR.lightseagreen200})`
const getColor = (isActive) => isActive ? ACTIVE_BTN_COLOR : DEACTIVE_BTN_COLOR
//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------


const ButtonClear = styled.button`
    background-color: transparent;
    border: none;
    // color: #848485;
    cursor: pointer;
    outline: none;
    padding: 0px;
`;

const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    margin-right: 16px;
`;

const ButtonLink = styled.button`
    align-items: center;
    background-color: transparent;
    border: none;
    color: ${COLOR.black200};
    cursor: pointer;
    display: inline-flex;
    flex-direction: row;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 2px 0px;
    text-transform: uppercase;
`;


const Group = styled.div`
   display: block;
    @media (min-width: 820px) {
        align-items: "center !important";
        flex-direction:row !important;
        }
    // display: none;

    //  @media (min-width: 820px) {
    //     align-items: ${p=> p.laptop && "center !important"};
    //     display: ${p=> p.laptop && "flex !important"};
    //     flex-direction: ${p=> p.laptop && "row !important"};
    //     }

`;

const HeaderContainer = styled.div`
    align-items: center;
    /* border-bottom: 1px solid ${COLOR.black700}; */
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 8px;
    padding: 6px 0px 6px;
    position: relative;

    @media (min-width: 992px) {
        margin-bottom: 16px;
    }
`;

const MobileMenu = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 600;
    margin-left: 12px;

    // @media (min-width: 992px) {
    //        display: ${p=> !p.laptop && "none"};
    // }
    //  @media (min-width: 820px) {
    //     display: ${p=> p.laptop && "none !important"};
    // }
`;

const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;

const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;

const TabButton = styled.button`
    background-color: transparent;
    border: none;
    /* color: ${p => p.active ? COLOR.black100 : COLOR.black500}; */
    color: white;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px 21px;
    text-transform: uppercase;
    transition: all 300ms ease;
    margin-right: 5px;
    border-radius: 7px;
    cursor:${p => p.disabled ? "not-allowed" : "pointer"}
`;

const Title = styled.span`
    display: inline-block;
    background-color: #ff682c;
    color: #ffffff;
    font-size: 12px;
    border-radius: 7px;
    padding: 4px 13px 4px 26px !important;
    font-weight: 500;
    line-height: 18px;
    text-transform: uppercase;
    letter-spacing: .5px;
`;

const TitleContainer = styled.div`
    align-items: center;
    display: inline-flex;
    flex-direction; row;
    position: relative;
    margin-bottom: 8px;

    @media (min-width: 992px) {
      margin-bottom: 0px;
    }
`;

const ButtonMoving = styled.div`
    animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both infinite;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
`;

const useStyles = makeStyles((theme) => ({
    manageColor: {
        backgroundColor: '#cf26b8 !important',
        margin: '5px'
    },
    gradebookColor: {
        backgroundColor: '#ffb100 !important',
        margin: '5px'


    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        '& > *': {
            margin: '2px',
        },
    }
}));


const VideoContainer = styled.div`
height: auto;
flex: 1;
justify-content: center;
`;
const Text = styled.div`
    font-size: 15px;
    color:${COLOR.black300};
    white-space: pre-line;
    text-align: left;
`;
const MyAssinContainer = styled.span`
    color: #10979D;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.64px;
`;


const AdminDashboard = ({
    activities,
    classActivities,
    classQuizzes,
    currentClass,
    currentOrg,
    currentUser,
    quizzes,
    userClasses,
    booksAllList,
    schools,
    classUsers,
    submissions,
    classNotes
}) => {
  	const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const welcomeVideo = useWelcomeVideos();
    const search = queryString.parse(location.search);
    const [classDrawer, toggleClassDrawer] = useState(false);
    const [activityDrawer, toggleActivityDrawer] = useState(false);
    const [quizDrawer, toggleQuizDrawer] = useState(false);
    const [activityData, setActivityData] = useState({});
    const [quizData, setQuizData] = useState({});
    const [dataLoading, setDataLoading] = useState(false);
    const [loading, setLoadingFlag] = useState(true);
    const [modalOpen, setModalState] = useState(false);
    const [cotationLoader, setCotationLoader] = useState(true);
    const isReviewAccount = currentUser?.reviewAccount || false
    const [data, setData] = useState({});
    const [dataDistrict, setDataDistrict] = useState({});
    const classes = useStyles();
    const isSchoologyUser = !!(currentUser && currentUser.schoologyid)
    const isCleverUser = !!(currentUser && currentUser.cleverId);
    const isCanvasUser = !!(currentUser && currentUser.canvas_id);
    const isGoogleUser = !!(currentUser && currentUser.googleId);
    const isClassLinkuser = !!(currentUser && currentUser.classlinkid);
    const isUserFromOtherPlatform =  isSchoologyUser || isCleverUser || isGoogleUser || isClassLinkuser || isCanvasUser
    const cotationRef = useRef(null)
    const currentUserId = get(currentUser,"id")
    const [initialSubmission,setInitialSubmission] = useState([])
    const [,,,listAllclassSchoologyGradeCategory] = useSchoologyGradeCategory()
    const [contentLoaderMessage,setContentLoaderMessage] = useState('')
    const [,listSchoologyAssignment] = useSchoologyAssignment()
    const  { fetchClassGameActivity } = useClassGameActivity()
    const {createCollectionNotification} = useCollectionNotification();
    const { quotesData = [] } = useUI();
    if (!cotationRef.current) {
        cotationRef.current = getRandomCotation(quotesData);
    }
    const [durationSection, setDurationSection] = useState(false);
    const filterClassUsers = filter(classUsers, (user) => user?.role !== 'teacher' && user?.active === true).map(user => user.id);
    const [popupMessage, setPopupMessage] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const deviceType = useMobileDeviceDetection();
    const tab = useTabletDetection();
    const mobile = useIsMobileDevice();
    const isTabletFull = useFullScreenTabDetect();
    const demoStatus = useDemoStatus();
    const orgPermissions = useCurrentOrgPermission();
    const isTeacherHome = location.pathname == "/teacher/home" || location.pathname == "/student/home" || currentUser?.role == "parent"
    const laptop =  !tab && !mobile;
    const { loading: classBooksLoading } = useClassBooks()

    const [fetchSelectedRubric,setFetchRubricId] = useState(null);
    const [is_mobile_menu, setMobileMenu] = useState(false);
    const [isExpand, setIsExpand] = useState(() => {
        const saved = localStorage.getItem('isExpand');
        return saved === 'true';
    });
    useEffect(() => {
        localStorage.setItem('isExpand', isExpand);
    }, [isExpand]);

    const getWelcomeVideoUrl = async () => {
        if (!welcomeVideo?.id) {
            await dispatch(handleGetWelcomeVideos());
        }
    }

    useEffect(() => {
        getWelcomeVideoUrl();
    }, []);

    useEffect(() => {
        const is_laptop = !tab && !mobile;
        const onResize = () => {
            if (window.innerWidth >= 992) {
                setMobileMenu(false)
            } else if (window.innerWidth < 992) {
                if (is_laptop && window.innerWidth > 820) {
                    setMobileMenu(false)
                } else {
                    setMobileMenu(true)
                }
            }
        };
        onResize();
        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, [tab, mobile]);

    
    useEffect(() => {
        const body = document.querySelector('body');
        if (body) body.scrollTop = 0;
    }, [location.key]);

    useEffect(() => {
        async function fetchData() {
            try {
                await getCurrentUser();
            } catch {
                navigate('/');
            }
        }
        fetchData();
    }, []);
    const listCurrentClassInfo = async () => {
        if (get(currentClass, "id")) {
            const current_user_id = get(currentClass, "id")
            await Promise.allSettled([
                 dispatch(handleListClassActivities(current_user_id)),
                 dispatch(handleListClassQuizzes(current_user_id)),
                 dispatch(handleListClassUsers(current_user_id)),
                 dispatch(handleListClassSubmissions(current_user_id))  
            ])
           
            listAllclassSchoologyGradeCategory()
        }
    }
    const listAllAssignments = async () => {
        return;
        if (!Array.isArray(activities) || activities.length == 0) {
           await  dispatch(handleListActivities());
        }
       
        if (!Array.isArray(quizzes) || quizzes.length == 0) {
          await   dispatch(handleListQuizzes());
        }
        if(currentUser.schoologyid){
            listSchoologyAssignment(currentClass.sectionId)
        }
        await dispatch(handleListCustomAssignment(get(currentUser,"role"),get(currentUser,"id")))
    }
    const listOrgInfo = async () => {
        if (has(currentOrg, "id")) {
            dispatch(handleListOrgsByParent(get(currentOrg, "id")));
            dispatch(handleListOrgUsers([currentOrg, ...schools]));
        }
    }
    const listInstruction = async() =>{
        if(has(currentUser, "id")){
            await dispatch(handleListInstructionByUser(currentUser.id))
        }
         
    }
    const fetchApis = async () => {
        try {
        setLoadingFlag(true);
        setCotationLoader(true);
        const currentClassId = sessionStorage.getItem("cureentClassId")
        if ((currentClassId && currentClassId === currentClass?.id) || (!currentClass?.id && currentClassId == "noclasssid")) {
            setLoadingFlag(false)
            setCotationLoader(false);
            setContentLoaderMessage(``)
        }
        if(userClasses&&userClasses.length==0 && !isUserFromOtherPlatform){
            navigate("/teacher/home")
        }
        await Promise.allSettled([
            listCurrentClassInfo(),
            listAllAssignments(),
            fetchClassGameActivity()
        ]).then(()=>{
        })

        sessionStorage.setItem('coatationLoader', true)
        sessionStorage.setItem("cureentClassId", currentClass?.id ?? "noclasssid")
        setLoadingFlag(false);
        setCotationLoader(false);
        // Api call after load
        await Promise.allSettled([
            dispatch(handleGetUserPreference(currentUserId)),
            listOrgInfo(),
            listInstruction(),
            fetchClassGameActivity(),
            dispatch(handleSyncLicesneUses(currentUser.orgId,currentClass.id))
        ])
        setContentLoaderMessage(``)
        handleSchoology()
        handleCanvasUser()
        syncGradeForCanvas()
        handleGoogleClassRomm()
        if(has(currentClass,"id")){
            dispatch(handleListClassBookmarks(currentClass.id));
            dispatch(handleListBubbleClassNotes(currentClass.id));
            dispatch(handleListUserBooks(currentUser.id))
        }
        } catch (error) {
            console.error("Error fetching APIs:", error);
            if (error && error.message != "Network Error") {
                Sentry.captureException(`143 Error during fetching APIs in AdminDashboard ${error}.`);
            }
            setLoadingFlag(false);
            setCotationLoader(false);
            setContentLoaderMessage(`Error loading data`);
        }
    };
    const handleCanvasUser = async () => {
       if(currentUser&&currentUser.canvas_id){
         await handeleCanvasUserClasses(null, currentUser.canvas_id, currentUser.canvas_auth_id)
         await dispatch(handleListCanvasAssignmentCat(currentUser.canvas_id,currentClass.canvas_id,currentUser.canvas_auth_id))
       }
    }
    const handleSchoology = async () => {
        try {
            if (has(currentUser,"schoologyid")&&currentUser.schoologyid) {
                await dispatch(handleListClassUsers(currentClass.id));
            }
        } catch (error) {
            Sentry.captureException(`372 Error during handleSchoology: ${error}`);
        }
    }
    const handleGoogleClassRomm = async () => {
        try {
            if (has(currentUser,"googleId")&&currentUser.googleId) {
                await handleSyncClassworkAssignment(currentUser.googleId,currentClass.id);
                await handleSyncClassworkGeades(currentUser.googleId,currentClass.id,currentClass.googleId);
                await  dispatch(handleListClassSubmissions(get(currentClass, "id")))
            }
        } catch (error) {
            Sentry.captureException(`373 Error during handleGoogleClassRomm: ${error}`);
        }
    }
    useEffect(()=>{
        if(submissions?.length>0&&initialSubmission.length==0){
            setInitialSubmission(submissions)
        }
    },[submissions])
    useEffect(() => {
        if (currentUser && currentUser.schoologyid && (classActivities?.length > 0 || classQuizzes?.length > 0) & !cotationLoader&&initialSubmission?.length>0) {
            getGradesFromScoology();
            getAssignmentFromSchoology();
        }
    }, [classActivities,classQuizzes,cotationLoader,initialSubmission])

    const getGradesFromScoology = debounce(async () => {

        try {
            if (currentClass?.sectionId) {
                await handleSyncSchoologyClassesGrades(currentUser.id, currentClass.id);
                // await handleSyncGradesToSchoology(currentUser.id, currentClass.id)
                // await dispatch(handleListClassSubmissions(currentClass?.id))
            }

        } catch (error) {
            console.log(error, "bid-err");
            Sentry.captureException(`374 Error during getGradesFromScoology: ${error}`);
        }

    },1000)
    const syncGradeForCanvas = debounce(async () => {
        try {
            if (currentClass?.canvas_id) {
                await handleSyncGrade(currentUser.canvas_id,currentClass.canvas_course_id , currentClass.canvas_id, currentUser.canvas_auth_id )
                await handleSyncAssignment(currentUser.canvas_id,currentClass.canvas_course_id , currentClass.canvas_id, currentUser.canvas_auth_id )
                await handleSyncClassGradeToCanvas(currentClass.id,currentUser.id)
                dispatch(handleListClassSubmissions(get(currentClass, "id")))
                dispatch(handleListClassActivities(get(currentClass, "id")));
                dispatch(handleListClassQuizzes(get(currentClass, "id")));
            }
        } catch (error) {
            console.log(error, "bid-err");
            Sentry.captureException(`375 Error during syncGradeForCanvas: ${error}`);
        }

    },1000)
    const getAssignmentFromSchoology = debounce(async () => {
        try {
            if (currentClass?.sectionId) {
                await handleSyncAssignmentDataSchoology(currentClass.id, currentUser.schoologyid)
            }
        } catch (error) {
            console.log(error, "bid-err");
            Sentry.captureException(`376 Error during getAssignmentFromSchoology: ${error}`);
        }
    },2000)
    useEffect(() => {
        fetchApis();
        setInitialSubmission([])
    }, [currentClass])

    useEffect(() => {
        // Validar si usuario es nuevo
        // if (currentUser?.newUser) {
        //     if (!cotationLoader) {
        //         setModalState(true);
        //     }
        // }
        if (!cotationLoader) {
            setModalState(true);
        }
    }, [currentUser, cotationLoader])
    const handleCloseVideo = (() => {
        currentUser.newUser = false;
        setModalState(false);
    });

    const generateCode = async () => {
        const code = [...Array(10)].map(i => (~~(Math.random() * 36)).toString(36)).join('');
        const exists = await dispatch(handleCheckCode(code));

        if (exists) {
            generateCode();
        } else {
            setData({
                ...data,
                displayName: '',
                code
            })
            setDataDistrict({
                ...dataDistrict,
                displayName: '',
                code
            })
        }
    };



    const getClass = async (hasClassLoad, classId) => {
        if (hasClassLoad) {

            const classes = await dispatch(handleListUserClasses(currentUserId));
            if (classId) {
                await dispatch(handleGetClass(classId));
            }
            else if (classes.length > 0) {
                await dispatch(handleGetClass(classes[0].id));
            }
            toggleClassDrawer(false);
        };
    }


  


    const updateActivity = async (e) => {
        e.preventDefault();
        const configAssignment = get(activityData, 'data.config_assignment') || get(activityData, 'config_assignment');
        const isEngageAssignment = configAssignment?.isFrom === 'engagement';
        
        const notificationData = {
            id: v4(),
            classId: get(currentClass, 'id', ''),
            displayName: get(activityData, 'displayName', ''),
            senderId: get(currentUser, 'id', ''),
            receiversId: filterClassUsers,
            modified: dayjs().toISOString(),
            data: {
                chapter: get(activityData, 'data.chapter', ''),
                page: get(activityData, 'data.page', ''),
                id: get(activityData, 'data.id', ''),
                scheduleAt: activityData?.scheduleAt,
                ...(isEngageAssignment && configAssignment ? { config_assignment: configAssignment } : {}),
            },
            message: `Your teacher Updated this Activity`,
            type: 'update_activity',
            userSeen: []
        }
        if (activityData && activityData.sAssignmentId && currentClass.sectionId) {
            if (activityData.sAssignmentId && currentClass.sectionId) {
                let u = await updateAssignmentToSchoology(activityData)
            }
        }
        if (activityData && activityData.canvas_id && currentClass.canvas_id) {
            const assignmentData =  [{
                "canvas_user_id": currentUser.canvas_id,
                "canvas_id": activityData.canvas_id,
                "canvas_section_id": currentClass.canvas_id,
                "canvas_course_id": currentClass.canvas_course_id,
                "due_date": get(activityData, "dueDate"),
                "weightage": get(activityData, "weightage"),
                "displayName": get(activityData, "displayName"),
                "max_point":activityData.max_point,
                "unlock_at": activityData?.scheduleAt || "",
            }]
            await handleUpdateCanvasAssignment(currentUser.canvas_id,assignmentData,currentUser.canvas_auth_id)
        }
        setDataLoading(true);
        if(currentClass.googleId&&activityData.googleId){
            await handleUpdateGoogleAssignment(currentUser.googleId,activityData,currentClass.googleId,activityData.googleId)
        }
        await dispatch(handleUpdateClassActivity(
            activityData.id,
            {
                ...activityData,
                retakes:  typeof activityData.retakes =="string" ? activityData.retakes.trim():activityData.retakes,
                dueDate: activityData.dueDate,
                lateDate: activityData.lateDate,
                timeDuration: activityData.timeDuration,
                classes: activityData.classes,
                weightage: activityData.weightage,
                displayName: activityData.displayName,
                classId:activityData.classId,
                rubrics_id:  fetchSelectedRubric
            },
            activityData.updateTOAllClass
        ));
        await dispatch(handleListClassActivities(currentClass.id));
        sendNotifications(notificationData)
        toggleActivityDrawer(false);
        setDataLoading(false);
        setActivityData({});
        setDurationSection(false)
    };
    const updateAssignmentToSchoology = async (quizeDataforCreate) => {
        let sectionId = currentClass.sectionId;
        const classConfig = find(quizeDataforCreate.classes, ['id', currentClass.id])
        if (classConfig && classConfig.sectionId) {
            sectionId = classConfig.sectionId;
        }
        if (currentUser.schoologyid && sectionId) {
            const classConfig = find(quizeDataforCreate.classes,['id',currentClass.id])
            let data = {
                "title": quizeDataforCreate.displayName,
                "due": `${quizeDataforCreate.dueDate}`,
                "grading_category":get(classConfig,"schoologyCategory")?get(classConfig,"schoologyCategory"): quizeDataforCreate.schoologyCategory
            }
            return  dispatch(handleUpdateSchoologyAssignment(sectionId,currentUser.id,data, quizeDataforCreate.sAssignmentId));
        }
        return null
    }

 



    const sendNotifications = async (notificationData) => {  
        try {
        createCollectionNotification(notificationData, get(currentClass, 'id', ''));
        } catch (error) {
            Sentry.captureException(`406 Error during sendNotifications: ${error}`);
            console.log(error, "error")
        }
    }


    const updateQuiz = async (e) => {
        e.preventDefault();
        const configAssignment = get(quizData, 'data.config_assignment') || get(quizData, 'config_assignment');
        const isEngageAssignment = configAssignment?.isFrom === 'engagement';
        
        const notificationData = {
            id: v4(),
            classId: get(currentClass, 'id', ''),
            displayName: get(quizData, 'displayName', ''),
            senderId: get(currentUser, 'id', ''),
            receiversId: filterClassUsers,
            modified: dayjs().toISOString(),
            data: {
                chapter: get(quizData, 'data.chapter', ''),
                page: get(quizData, 'data.page', ''),
                id: get(quizData, 'data.id', ''),
                classes: get(quizData, 'classes', []).map((cls) => ({
                    id: cls?.id,
                    users: cls?.users?.length > 0 ? cls?.users : null
                })),
                ...(isEngageAssignment && configAssignment ? { config_assignment: configAssignment } : {}),
            },
            message: `Your teacher Updated this Quiz`,
            type: 'update_quiz',
            userSeen: []
        }
        setDataLoading(true);
        if (quizData.sAssignmentId && currentClass.sectionId) {
            let u = await updateAssignmentToSchoology(quizData)
        }
        if(currentClass.googleId&&quizData.googleId){
            await handleUpdateGoogleAssignment(currentUser.googleId,quizData,currentClass.googleId,quizData.googleId)
        }
        if (quizData && quizData.canvas_id && currentClass.canvas_id) {
            const assignmentData =  [{
                "canvas_user_id": currentUser.canvas_id,
                "canvas_id": quizData.canvas_id,
                "canvas_section_id": currentClass.canvas_id,
                "canvas_course_id": currentClass.canvas_course_id,
                "due_date": get(quizData, "dueDate"),
                "weightage": get(quizData, "weightage"),
                "displayName": get(quizData, "displayName"),
                "max_point":quizData.max_point,
                "unlock_at": quizData?.scheduleAt || "",
            }]
            await handleUpdateCanvasAssignment(currentUser.canvas_id, assignmentData ,currentUser.canvas_auth_id)
        }
        await dispatch(handleUpdateClassQuiz(
            quizData.id,
            {
                ...quizData,
                retakes: typeof quizData.retakes == "string" ? quizData.retakes.trim() : quizData.retakes,
                dueDate: quizData.dueDate,
                lateDate: quizData.lateDate,
                timeDuration: quizData.timeDuration || 0,
                classes: quizData.classes,
                weightage: quizData.weightage,
                displayName: quizData.displayName,
                scheduleAt: quizData.scheduleAt,
                classId:quizData.classId,
                rubrics_id:  fetchSelectedRubric
            },
            quizData.updateTOAllClass
        ));

        await dispatch(handleListClassActivities(currentClass.id));
        await dispatch(handleListClassQuizzes(currentClass.id));
        sendNotifications(notificationData);
        toggleQuizDrawer(false);
        setDataLoading(false);
        setQuizData({});
        setDurationSection(false)
    };


    const updateActivityData = (id, value) => {
        const val = value&&value.length > 1 && value[0] === '0' ? value.replace('0', '') : value;
        setActivityData(prevState => ({
            ...prevState,
            [id]: val
        }));
    };

    const updateQuizData = (id, value) => {
        const val = value&&value.length > 1 && value[0] === '0' ? value.replace('0', '') : value;
        setQuizData(prevState => ({
            ...prevState,
            [id]: val
        }));
    };

    const toolbarNav = () => {
        return {
            items: [
                {
                    key: 'home',
                    label: (
                        <ButtonClear onClick={() => navigate('/admin/class?view=home')}>
                            Home
                        </ButtonClear>
                    )
                },
                // {
                //     key: 'assignments',
                //     label: (
                //         <ButtonClear onClick={() => navigate('/admin/class?view=manage')}>
                //             Assignments
                //         </ButtonClear>
                //     ),
                //     disabled: userClasses?.length == 0
                // },
                {
                    key: 'gradebook',
                    label: (
                        <ButtonClear onClick={() => navigate('/admin/class?view=gradebook')}>
                            GradeBook
                        </ButtonClear>
                    ),
                    disabled: userClasses?.length == 0
                },
                ...(!isUserFromOtherPlatform ? [{
                    key: 'create_class',
                    label: (
                        <ButtonClear onClick={() => toggleClassDrawer(true)}>
                            Create Class
                        </ButtonClear>
                    )
                }] : []),
                {
                    key: 'class_data',
                    label: (
                        <ButtonClear onClick={() => navigate('/admin/class?view=classdata')}>
                            Class data
                        </ButtonClear>
                    ),
                    disabled: userClasses?.length == 0
                },
                {
                    key: 'how_to_videos',
                    label: (
                        <ButtonClear onClick={() => navigate('/how-to-videos')}>
                            How to Videos
                        </ButtonClear>
                    )
                },
                ...(currentUser?.role === 'admin' ? [{
                    key: 'logs',
                    label: (
                        <ButtonClear onClick={() => navigate('/logs')}>
                            Logs
                        </ButtonClear>
                    )
                }] : [])
            ]
        };
    };

   
    //  -- Delete Class -------------------
    const [deleteToggle, setDeleteToggle] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const deleteClass = async () => {
        setDeleting(true);
        await dispatch(handleDeleteClassData(currentClass.id));
        const listclass = await dispatch(handleListUserClasses(currentUserId))
        await dispatch(handleGetClass(listclass[0].id));
        const userToRemove = filter(classUsers, (user) => user.id != currentUserId);
        const orgId = !!currentOrg.parentId ? currentOrg.parentId : currentOrg?.id;
        await dispatch(handleDeleteUserFromOrganization(orgId, userToRemove.map(user => `'${user.id}'`)));
        setDeleting(false);
        setDeleteToggle(false);
    };

    const openEditQuiz = (quiz) => {
        if (quiz.timeDuration > 0) {
            setDurationSection(true)
        }
        setQuizData({
            editing: true,
            ...quiz
        });
        toggleQuizDrawer(true);
    }

    const openEditActivity = (activity) => {
        if (activity.timeDuration > 0) {
            setDurationSection(true)
        }
        setActivityData({
            editing: true,
            ...activity
        });
        toggleActivityDrawer(true);
    }
     const  onswithClass = async(class_id,displayName,class_data)=>{
        setCotationLoader(true)
        setContentLoaderMessage(`Moving to ${displayName}`)
        const classData = await dispatch(handleGetClass(class_id))
        if(classData && classData.id){
             classCardHandleStudentSync({ currentUser, classInfo: classData, dispatch })
        }
    }

    const onAssessments = () => {
        navigate("/exams");
    }
    const openAccessDenineMessage = () => {
        setOpen(true)
        setPopupMessage('Restricted access (legend)')
    }
    const resourceNav = () => {
        return {
            items: [
                {
                    key: 'graphic_organizers',
                    label: (
                        <PaddedBtn onClick={() => {
                             if (demoStatus) {
                                openAccessDenineMessage()
                                // onCloseMenuBook()
                            } else {
                                navigate('/graphic_organizers')
                                // onCloseMenuBook()
                            }
                        }}>
                            Graphic Organizers
                        </PaddedBtn>
                    )
                },
                {
                    key: '1wayteacher',
                    label: (
                        <PaddedBtn onClick={() => {
                              if (demoStatus) {
                                openAccessDenineMessage()
                                // onCloseMenuBook()
                            } else {
                                navigate('/Strategies')
                                // onCloseMenuBook()
                            }
                            
                        }}>
                            1WayTeacher
                        </PaddedBtn>
                    )
                }
            ]
        };
    };
    const handleClose = () => {
        setOpen(false);
    };

    const assignmentRef = useRef(null);
    const prevExpand = useRef(isExpand);
    useEffect(() => {
        if (prevExpand.current && !isExpand && assignmentRef.current) {
            // Only scroll when isExpand changes from true to false
           if (window.innerWidth <= 1228) {
            setTimeout(() => {
                assignmentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
          }
        }
        prevExpand.current = isExpand;
    }, [isExpand]);
    
    const handleExpandClick = () => {
        setIsExpand(!isExpand);
    };

    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}>
                <Alert onClose={handleClose} severity="error">
                    <strong>ALERT:</strong> {popupMessage}
                </Alert>
            </Snackbar>
            <Modal
                className={classes.modal}
                open={cotationLoader || classBooksLoading}
            >
                <VideoContainer>
                    <CotationLoader cotation={cotationRef.current} messages={contentLoaderMessage} />
                </VideoContainer>
            </Modal>
            <WelcomeVideo open={modalOpen} onClose={handleCloseVideo} welcomeVideo={welcomeVideo} />
        

            <Modal
                open={deleteToggle}
                onClose={() => setDeleteToggle(false)}
            >
                <ModalContent>
                    <Text><strong>{`Deleting this class will also delete the following:`}</strong></Text>
                    <Text>{"— All students from your roster\n— All grades and assessments submitted \n— All data related to this class (notes, questions, etc.) \n— You will never be able to get this data again Are you sure you want to delete it? "}</Text>
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => setDeleteToggle(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={deleteClass}
                            className={`${deleting ? "disabled-button" : ""}`}
                        >
                            {deleting ? <Loading size={20} white /> : 'Remove'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            <Drawer
                destroyOnHidden
                height='100%'
                className='assignments-drawer assignments-drawerCstm'
                onClose={() => {
                    toggleQuizDrawer(false);
                    setQuizData({});
                }}
                placement='top'
                open={quizDrawer}
                key='quizNew'
            >
                    <SentryWrap>
                        <QuizForm
                            data={quizData}
                            selectedAssignments={quizData?.selectedAssignments || []}
                            handleChange={e => updateQuizData(e.target.id, e.target.value)}
                            handleSubmit={quizData.editing ? updateQuiz : ()=>{}}
                            setDurationSection={setDurationSection}
                            durationSection={durationSection}
                            loading={dataLoading}
                            onClose={() => toggleQuizDrawer(false)}
                            handleRubric={(value)=> {
                                setFetchRubricId(value?.id || "")
                              }}
                        />
                    </SentryWrap>
               
            </Drawer>
            <Drawer
                height='100%'
                destroyOnHidden
                className='assignments-drawer assignments-drawerCstm'
                onClose={() => {
                    toggleActivityDrawer(false);
                    setActivityData({});
                }}
                placement='top'
                open={activityDrawer}
                key='activityNew'
            >
                <>
                    <SentryWrap>
                        <ActivityForm
                            data={activityData}
                            selectedAssignments={activityData?.selectedAssignments || []}
                            handleChange={e => updateActivityData(e.target.id, e.target.value)}
                            handleSubmit={activityData.editing ? updateActivity : ()=>{}}
                            setDurationSection={setDurationSection}
                            durationSection={durationSection}
                            loading={dataLoading}
                            onClose={() => toggleActivityDrawer(false)}
                            handleRubric={(value)=> {
                                setFetchRubricId(value?.id || "")
                              }}

                        />
                    </SentryWrap>
                </>
            </Drawer>
            <Drawer
             destroyOnHidden
                height='100%'
                onClose={() => {
                    toggleClassDrawer(false);
                    setData({});
                }}
                placement='top'
                open={classDrawer}
                key='classNew'
                className="addNewDrawer"
            >
                <>
                    <SentryWrap>
                        {classDrawer && <ClassForm
                            data={data}
                            dataBooks={{}}
                            listBooks={booksAllList}
                            setData={setData}
                            currentOrg={currentOrg}
                            currentUser={currentUser}
                            currentClass={currentClass}
                            classUsers={classUsers}
                            classActivities={classActivities}
                            classQuizzes={classQuizzes}
                            classNotes={classNotes}
                            //handleChange={e => updateClassData(e.target.id, e.target.value)}
                            //handleSubmit={createClass}
                            //loading={dataLoading}
                            userClasses={userClasses}
                            onClosed={(hasClassLoad, classId) => {
                              
                                setData({})
                                getClass(hasClassLoad, classId);
                                toggleClassDrawer(false)

                            }}
                        />}
                    </SentryWrap>
                </>
            </Drawer>
            <Row className="tabCollection wrapperAdmnDash wrapperAdmnAddOn">
                <Col className="contentAdmnDash" style={{ flex: deviceType ? 1 : "undefined", minWidth: deviceType ? "100%" : undefined }} 
                xs={{ span: 24 }} sm={24} xl={{
                    span: search.view === "home"
                        ? (isExpand ? 24 : 17)
                        : 24
                }} lg={{ span: search.view == "home" ? "" :(!search.view) ? 17 : 24 }}
                >
                <>
                    <div>
                        <Row>
                            <Col>
                              {!is_mobile_menu?  <Group laptop={laptop}>
                                    <ButtonGroup style={{flexWrap: laptop ? "wrap": "nowrap"}}  className="tabBtnGrup">
                                        <TabButton
                                            style={{ backgroundImage: getColor((search.view == "home" || !search.view)) }}
                                            active={search.view === 'home'} onClick={() => navigate('/admin/class?view=home')}>
                                            Home
                                        </TabButton>
                                        {/* <TabButton
                                            style={{ backgroundImage: getColor(search.view === 'manage') }}
                                            disabled={userClasses?.length == 0}
                                            active={search.view === 'manage'} onClick={() => navigate('/admin/class?view=manage')}>
                                            Assignments
                                        </TabButton> */}
                                        <TabButton
                                            style={{ backgroundImage: getColor(search.view === 'gradebook') }}
                                            disabled={userClasses?.length == 0}
                                            active={search.view === 'gradebook'} onClick={() => navigate('/admin/class?view=gradebook')}>
                                            Gradebook
                                        </TabButton>

                                        {(currentUser?.role === 'student' || currentUser?.role === 'teacher' || currentUser?.role === 'admin') && get(orgPermissions, 'exams', true) && !isTeacherHome && (
                                        <TabButton onClick={onAssessments} className='laptop-exam-button bg-linear-green-10'>
                                            Exams
                                        </TabButton>
                                        )}
                                        {!isUserFromOtherPlatform  && <TabButton
                                            style={{ backgroundImage: getColor(search.view === 'admin'),whiteSpace: "nowrap"  }}
                                            onClick={() => {
                                                generateCode();
                                                toggleClassDrawer(true);
                                            }}>
                                            Create Class
                                        </TabButton>}
                                        <TabButton
                                            style={{ backgroundImage: getColor(search.view === 'classdata'),  whiteSpace: "nowrap" }}
                                            disabled={userClasses?.length == 0}
                                            active={search.view === 'classdata'} onClick={() => navigate('/admin/class?view=classdata')}>
                                            Class data
                                        </TabButton>

                                        {(currentUser?.role === 'teacher') && get(orgPermissions, '1WAYTEACHER', true) && !isTeacherHome && (
                                             <Dropdown menu={resourceNav()} placement="bottomLeft" trigger={['click']}>
                                             <TabButton className='laptop-one-way-teacher-button bg-linear-green-10'>
                                                         1WAYTEACHER
                                                     </TabButton>
                                             </Dropdown>
                                        )}
                                        <div className="customLinksUpr how-to-videos">
                                            <ul className="customLinks">
                                                <li onClick={() => navigate('/how-to-videos')}>How to Videos</li>
                                                {currentUser?.role === 'admin' && (
                                                    <li onClick={() => navigate('/logs')}>Logs</li>
                                                )}
                                            </ul>
                                        </div>
                                    </ButtonGroup>
                                </Group>:null}
                            </Col>
                        </Row>

                        <HeaderContainer className='setHeadContainWdth'>
                            { <TitleContainer className='setTitleContainWdth'>
                                {/* <Mobicon src={mobileMenuimg} /> */}
                                {/* <MenuBook style={{ marginRight: '10px', marginTop: '-2px' }} /> */}
                                    {userClasses.length == 0 && !isUserFromOtherPlatform && (
                                        <>
                                            <ButtonMoving>
                                                <Button style={{ backgroundColor: 'red', color: 'white' }}
                                                    onClick={() => {
                                                        generateCode();
                                                        toggleClassDrawer(true);
                                                    }}
                                                    variant="contained"
                                                    type='submit'
                                                >
                                                    Create Class
                                                </Button>
                                            </ButtonMoving>
                                        </>
                                    )}
                                    
                                    {userClasses.length > 0 && (
                                        <>
                                            <Title className="breakTheSentence 1212 setCstmSpc">  <img src={locationImg} className="locationIcon" /> {currentClass?.displayName} ({currentClass?.code})</Title>
                                            {!isUserFromOtherPlatform && <Tooltip  overlayClassName="editToolsTip"  placement="bottom" title={isReviewAccount ? "Only for Review!" : "Edit"}>
                                                <ButtonClear className='setCstmSpc' onClick={() => {
                                                    if (isReviewAccount) {
                                                        return;
                                                    }
                                                    toggleClassDrawer(true);
                                                    setData(currentClass);
                                                }} style={{ marginLeft: '9px', display: 'inline-flex', color: '#ffffff', verticalAlign: 'middle', minWidth: '25px', minHeight: '25px', justifyContent: 'center', alignItems: 'center', borderRadius: '13px', backgroundImage: 'linear-gradient(to right, #0097b2, #00578d)' }}>
                                                    <Edit style={{ fontSize: '18px', marginBottom: '-1px' }} />
                                                </ButtonClear>
                                            </Tooltip>}
                                            {userClasses.length > 1 && !isUserFromOtherPlatform && !isReviewAccount && (
                                                <Tooltip placement="bottom" title="Delete">
                                                    <ButtonClear className='setCstmSpc' onClick={() => setDeleteToggle(true)} style={{ marginLeft: '6px', display: 'inline-flex', color: '#ffffff', verticalAlign: 'middle', minWidth: '25px', minHeight: '25px', justifyContent: 'center', alignItems: 'center', borderRadius: '13px', backgroundImage: 'linear-gradient(to right, #0097b2, #00578d)' }}>
                                                        <Close style={{ fontSize: '20px', marginBottom: '-1px' }} />
                                                    </ButtonClear>
                                                </Tooltip>
                                            )}
                                            {search.view == "classdata" && (
                                                <button className='studentCountBtn setCstmSpc'><label>Student Count</label><span>{classUsers?.length === 0 ? 0 : filter(classUsers, ["active", true]).length - 1}</span><img src={userRobert} style={{ width: 'auto' }} /></button>
                                            )}
                                        </>
                                    )}
                            </TitleContainer>
                            }
                           {is_mobile_menu? <MobileMenu className="TabMobMenuUpr" laptop={laptop} >
                                <Dropdown className="TabMobMenu" menu={toolbarNav()} placement="bottomRight" trigger={['click']}>
                                    <ButtonLink onClick={e => e.preventDefault()}>
                                        {/* <MenuOutlined style={{ fontSize: '18px' }} /> */}
                                            <Tune style={{ fontSize: '32px' }} />
                                            {/* <FilterOutlined /> */}
                                    </ButtonLink>
                                </Dropdown>
                            </MobileMenu>:null}
                        </HeaderContainer>
                    </div>
                    {(search.view == "home" || !search.view) && (
                        <>
                            <Section
                                description="Below are the chapters for the book. Clicking on a chapter will display the book."
                                header='Home'>
                                    {loading ? (
                                        <AdminDashboardHomeSkeletonPage />
                                    ) : (
                                        <SentryWrap>
                                            <ChapterManagementBook />
                                        </SentryWrap>
                                    )}
                            </Section>
                        </>
                    )}

                    {search.view === 'gradebook' && (
                        <>
                            <Gradebook
                                itemloading={cotationLoader || classBooksLoading}
                                handleEditQuiz={quiz => {
                                    openEditQuiz(quiz);
                                }}
                                handleEditActivity={activity => {
                                    openEditActivity(activity);
                                }}
                                onswithClass={onswithClass}
                            />
                        </>
                    )}
                    {search.view === 'classdata' && (
                        <Section header='Class Data'>
                            {loading ? (
                                <AdminDashboardClassDataSkeletonPage />
                            ) : (
                                <SentryWrap>
                                    <AdminVisuals />
                                </SentryWrap>
                            )}
                        </Section>
                    )}
                </>
                </Col>

                {search.view == "home" && (
                    !(mobile || tab || isTabletFull) ? (
                        <div onClick={handleExpandClick} className="expandButtonTcher">
                        {isExpand &&
                           <MyAssinContainer>
                              My Assignments {" "}
                              <img src={myAssignSvg} alt="" />
                            </MyAssinContainer>
                            }
                        </div>
                    ) : ''
                )}
                
                {!isExpand && (
                    (search.view === "home" || !search.view) && (
                        <Col
                            ref={assignmentRef}
                            className="sidebarAdmnDash assignment-list-dashboard"
                            xs={{ span: 24 }}
                            sm={24}
                            lg={{ span: search.view !== "home" ? 7 : undefined }}
                            xl={{ span: search.view === "home" && 7 }}
                            style={{ minWidth: deviceType ? "100%" : undefined }}
                        >
                            {/* <div className='teacherAssignmentList'>
                                <AssignmentList headerChild={window.innerWidth >= 1200 ? <EyeFilled onClick={() => setIsExpand(!isExpand)} style={{ fontSize: 22, cursor: "pointer",marginLeft:8 }} />: ''} />
                            </div> */}
                            <div className='teacherAssignmentList'>
                                <AssignmentList
                                    headerChild={
                                     !(mobile || tab || isTabletFull) ? (
                                        <EyeFilled
                                        onClick={() => setIsExpand(!isExpand)}
                                        style={{ fontSize: 22, cursor: "pointer", marginLeft: 8 }}
                                        />
                                    ) : ''
                                    }
                                />
                            </div>

                        </Col>
                    )
                )}

            </Row>
        </>
    );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    activities: state.activities,
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    currentClass: state.currentClass,
    currentOrg: state.currentOrg,
    currentUser: state.currentUser,
    quizzes: state.quizzes,
    userClasses: state.userClasses,
    booksAllList: state.booksAllList,
    schools: state.schools,
    users: state.users,
    classUsers: state.classUsers,
    submissions: state.submissions,
    classNotes: state.classNotes,
});

export default connect(mapStateToProps, null)(AdminDashboard);